<template>
  <v-dialog v-model="openDialog" :max-width="800">
    <v-card>
      <v-card-title class="primary-background">
        Choix d'un modèle de carte
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="openDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-select
              label="Type de la carte"
              :items="cardModelTypes"
              hide-details
              v-model="selectedTypeId"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-subheader
              >{{ sortedCardModels.length }} modèles de carte</v-subheader
            >
            <v-data-table
              :items="sortedCardModels"
              disable-pagination
              hide-default-footer
              sort-by="description"
              :headers="modelsHeaders"
              dense
              fixed-header
              height="400"
              class="table-cursor"
              @click:row="(item) => selectModel(item)"
            >
              <template #[`item.check`]="{ item }">
                <v-icon v-if="item.id == selectedModelIdProxy"
                  >mdi-check</v-icon
                >
              </template>
              <template #[`item.duration`]="{ item }">
                {{ libelleDuration(item.duration) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from "@vue/composition-api";
import { useTimeUtils } from "../../composables/time";
import { date } from "@/composables/date";

export default defineComponent({
  props: {
    selectedModelId: Number,
    cardModels: Array,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { secondsToHigherUnit } = useTimeUtils();
    const { libelleDuration } = date();

    /* Variables */
    const cardModelTypes = [
      { value: 1, text: "Décompte" },
      { value: 2, text: "Temps" },
      { value: 3, text: "Séminaire" },
      { value: 4, text: "Post-payée" },
    ];
    const cardModelOrigins = [
      { value: 1, text: "Interne" },
      { value: 2, text: "CB" },
      { value: 3, text: "Gratuit" },
      { value: 4, text: "e-Ticketing client" },
      { value: 5, text: "Exception MAC" },
      { value: 6, text: "Conférence" },
    ];
    const selectedModelRef = ref({});
    const selectedTypeId = ref(0);
    const modelsHeaders = [
      { text: "", value: "check", width: "50px", sortable: false },
      { text: "ID", value: "id" },
      { text: "Description", value: "description", width: "250px" },
      { text: "Durée", value: "duration" },
      { text: "Type", value: "cardType.description" },
      {
        text: "Nb sessions max",
        value: "simultaneousSessionsNum",
        width: "50px",
      },
    ];

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });
    const selectedModelIdProxy = computed({
      get: function () {
        return props.selectedModelId;
      },
      set: function (value) {
        emit("update:selectedModelId", value);
      },
    });
    const sortedCardModels = computed(function () {
      let result = props.cardModels;

      // on filtre sur le type
      if (selectedTypeId.value > 0) {
        result = result.filter(
          (model) => model.cardType.id == selectedTypeId.value
        );
      }

      return result;
    });

    /* Méthodes */
    const selectModel = function (model) {
      if (selectedModelIdProxy.value == model.id) {
        selectedModelIdProxy.value = -1;
      } else {
        selectedModelIdProxy.value = model.id;
      }
      openDialog.value = false;
    };

    /* Cycle de vie */
    onMounted(() => {
      props.cardModels.forEach((model) => {
        model.selected = model.id == selectedModelIdProxy.value;
      });
    });

    return {
      cardModelTypes,
      openDialog,
      selectedModelRef,
      selectedTypeId,
      cardModelOrigins,
      sortedCardModels,
      secondsToHigherUnit,
      selectedModelIdProxy,
      selectModel,
      modelsHeaders,
      libelleDuration,
    };
  },
});
</script>
